import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

export const GeneralStylePublic = styled.div`
  margin-left: 2%;
  width: 96%;
  margin-top: 2rem;
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiPaper-root {
    margin-top: 2rem;
    box-shadow: none;
  }
  .MuiPaper-root > .MuiToolbar-root {
    display: none;
  }
  .MuiTableCell-root {
    padding: 4px;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const useStyles = makeStyles((theme) => ({
  active: {
    "& svg": {
      color: theme.button.primary,
    },
    "&:disabled svg": {
      color: theme.neutral.gray[1200],
    },
  },
  delete: {
    color: theme.status.error,
  },
  buttonActive: {
    background: theme.button.primary,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  tabs: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const TableActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  label {
    font-size: 1.286rem;
    color: ${({ theme }) => theme.primary.purple};
    font-weight: 600;
  }
`;

export const RightSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ContentDownloadFile = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const TextDownloadFile = styled.span`
  text-decoration: none;
  color: ${({ theme }) => theme.neutral.black};
  &:hover {
    text-decoration: underline;
  }
`;

export const ContentFilters = styled.div`
  width: 100%;
  display: flex;
`;
